const zh_CN = {
    // homepage
    homepage_title: '扫二维码下载日历清单手机版',
    homepage_slogn: '日历清单手机版本',
    homepage_ios_download: 'AppStore审核中...',
    homepage_download: '立即下载',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',


    // 手机下载
    phonedownload_title: '扫二维码下载日历清单手机版',
    phonedownload_slogan: '手机版日历清单可以和电脑版、iPad、Pad版实时同步，随时随地记录琐事',
    phonedownload_send_vip: '安装日历清单App，送VIP会员',
    phonedownload_screenshot: '屏幕快照',
    phodedownload_macos: '日历清单macOS电脑版本',
    phodedownload_windows: '日历清单windows电脑版本',
    phodedownload_otherbutton: "立即查看",
    phodedownload_about: '联系我们',
    phodedownload_copyright: '京ICP备18016017号-7',

    //特点
    feature_no_ad: '无广告',
    feature_easy: '月视图、简洁易用',
    feature_reminder: '自定义提醒',
    feature_countdown: '倒数纪念日',

    vip_task_succ:'领取成功，请下载手机版激活VIP',
    vip_task_error:'领取失败',

    group_slogn : "日历清单团队版邀请",

    
    //课程表
    tt_title: '日历清单',
    tt_share_1: '向您分享了',
    tt_share_2: '课程表',
    tt_share_show_1: '您用“日历清单”APP扫二维码，电脑端和手机端会自动显示出',
    tt_share_show_2: '的课程表',
    tt_share_scan_1: '用',
    tt_share_scan_2: '“日历清单”APP扫码',
    tt_share_succ: '同步成功',
    
    // V2版权信息
    v2_copyright: '联系我们 service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. All rights reserved. | 京ICP备18016017号-7',
    v2_download_appstore: 'Download on the App Store',
    v2_download_googleplay: 'GET IT ON Google Play',
    
    // V2中间部分内容
    v2_main_title: '日历清单 手机端',
    v2_main_title_part1: '日历清单',
    v2_main_title_part2: '手机端',
    v2_main_description: '您可以通过 App Store 或者手机应用商店,搜索<span class="name">日历清单</span>下载安装',
    v2_download_ios: '下载 iOS',
    v2_download_android: '下载 Android',
    v2_download_harmonyos: '下载 HarmonyOS',
    v2_sync_status: '同步完成!上传1条记录,下载0条记录',
    v2_feature_title: '多端数据同步',
    v2_feature_description: '可在手机、平板、电脑等,多设备之间即时同步数据'
}
export default zh_CN;